import React, { FunctionComponent, ReactNode, useState } from "react";

import { ButtonBackgroundColor, ComponentSize, Display, Divider, JustifyContent, Layout, LocalizationProvider, ModalWindow, SpacingSize, TextButton, TextColor } from "@multiweb/reactComponents";
import { bemClassNames } from "@multiweb/reactUtils";

export type BasicDialogComponentProps = {
    readonly children: ReactNode[];
    readonly headerLocKey: string;
    readonly noItemsLocKey: string;
    readonly buttonDisabled: boolean;
    readonly onCloseChange: () => void;
    readonly onConfirmClick: () => void;
    readonly cancelText: string;
    readonly confirmationButtonText: string;
};

const classNames = bemClassNames("basic-dialog-component");
const dialogClassName = classNames();
const noItemsClassName = classNames("no-items-message");
const containerClassName = classNames("items-container");
const basicDialogHeaderClassName = classNames("basic-dialog-header");

export const BasicDialogComponent: FunctionComponent<BasicDialogComponentProps> = ({
    children,
    headerLocKey,
    noItemsLocKey,
    buttonDisabled,
    onCloseChange,
    onConfirmClick,
    confirmationButtonText,
    cancelText,
}) => {
    const [isDisplayed, setIsDisplayed] = useState(true);

    const closeEdit = () => {
        setIsDisplayed(false);
    };

    const handleOnCofirmClick = () => {
        onConfirmClick();
        closeEdit();
    };

    const noItemsMessageRenderer = () => (
        <div className={noItemsClassName} >
            <LocalizationProvider locKey={noItemsLocKey} />
        </div>
    );

    return (
        <ModalWindow closeByOuterClick onCloseChange={onCloseChange} defaultWidth={300} defaultHeight={400} {...{ isDisplayed }}>
            <div className={dialogClassName}>
                <div className={basicDialogHeaderClassName}>
                    <LocalizationProvider locKey={headerLocKey} />
                </div>
                <Divider />
                <div className={containerClassName}>
                    {children.length === 0 ?
                        noItemsMessageRenderer() : children
                    }
                </div>
                <Layout display={Display.flex} justifyContent={JustifyContent.flexEnd} spacingSize={SpacingSize.s}>
                    <TextButton size={ComponentSize.large} onClick={closeEdit} text={cancelText} color={TextColor.colorPrimary} />
                    <Layout spacingSizeLeft={SpacingSize.s} />
                    <TextButton
                        onClick={handleOnCofirmClick}
                        text={confirmationButtonText}
                        disabled={buttonDisabled}
                        size={ComponentSize.large}
                        backgroundColor={ButtonBackgroundColor.buttonPrimary}
                        color={TextColor.whitePrimaryFixed} />
                </Layout>
            </div>
        </ModalWindow>
    );
};
